var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auto-stats"},_vm._l((_vm.stats),function(stat,index){return _c('div',{key:index},[_vm._v("\n\t\t"+_vm._s(stat.value)+"\n\t\t"),_c('span',[_vm._v(_vm._s(stat.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }